import { useEffect, useReducer } from "react";
import { DEVICE_MAX_SIZE } from "constant";

const getScreenDetect = (userAgent, element) => {
  const resizeWidth = element ? element.clientWidth : window.innerWidth;
  const resizeHeight = element ? element.clientHeight : window.innerHeight;
  const innerWidthCondition = resizeWidth > DEVICE_MAX_SIZE.medium;

  const isAndroid = () => Boolean(userAgent.match(/Android/i));
  const isIos = () => Boolean(userAgent.match(/iPhone|iPad|iPod/i));
  const isOpera = () => Boolean(userAgent.match(/Opera Mini/i));
  const isWindows = () => Boolean(userAgent.match(/IEMobile/i));
  const isSSR = () => Boolean(userAgent.match(/SSR/i));

  const isMobile = () =>
    Boolean(isAndroid() || isIos() || isOpera() || isWindows());
  const isDesktop = () =>
    Boolean(!isMobile() && !isSSR() && innerWidthCondition);

  return {
    isMobile,
    isDesktop,
    isAndroid,
    isIos,
    isSSR,
    resizeWidth,
    resizeHeight,
  };
};
const useSizeDetect = (element = null) => {
  const userAgent =
    typeof navigator === "undefined" ? "SSR" : navigator.userAgent;
  const [, forceRender] = useReducer((s) => s + 1, 0);

  useEffect(() => {
    window.addEventListener("resize", resize);
    return () => {
      window.removeEventListener("resize", resize);
    };
  }, [element]);

  const resize = () => {
    forceRender();
  };

  return getScreenDetect(userAgent, element);
};

export default useSizeDetect;
